module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/BingSearch.c18bf677.png";